import React from 'react';
import { RoundInputNumber } from '../../app/components';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import './styles.css';

const SizeStep = ({
  fields, onInputKeyDown, onIncreaseBedrooms, onDecreaseBedrooms, assignRef,
}) => (
  <div className="step-content size-step">
    <h2>Stærð</h2>
    {fields.type.value === 'room' ?
      <p>
        Við mælum stærð eigna í fermetrum.<br />Hvað er herbergið margir fermetrar?
      </p>
    :
      fields.type.value === 'commercial' ?
        <p>
          Við mælum stærð eigna í fermetrum.<br />Hvað er atvinnuhúsnæðið margir fermetrar?
        </p>
      :
        <p>
          Við mælum stærð eigna í fjölda svefnherbergja og í fermetrum.<br />Hvað er þín eign stór?
        </p>
    }
    {(fields.type.value !== 'room' && fields.type.value !== 'commercial') &&
      <div className="input-wrapper">
        <div className="label"><span className="icon-bedroom-icon" /><p>Svefnherbergi</p></div>
        <div className="input">
          <RoundInputNumber
            value={fields.bedrooms.value}
            onIncrease={e => onIncreaseBedrooms(e, fields)}
            onDecrease={e => onDecreaseBedrooms(e, fields)}
            inputColor="#222222"
            inputBackgroundColor="#00e39a"
            buttonsColor="#606060"
            buttonsBackgroundColor="#ffffff"
          />
        </div>
      </div>
    }
    <div className="input-wrapper">
      <div className="label"><span className="icon-size-icon" /><p>Fermetrar</p></div>
      <div className="input size-input">
        <TextField
          value={fields.size.value}
          onKeyDown={onInputKeyDown}
          ref={assignRef ? c => assignRef('size', c) : null}
          type="number"
          pattern="[0-9]*"
          min="0" hintText="100"
        >
          <NumberFormat {...fields.size} thousandSeparator="." />
        </TextField>
        <span>fm</span>
      </div>
    </div>
  </div>
);

SizeStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  onInputKeyDown: React.PropTypes.func,
  assignRef: React.PropTypes.func,
  onIncreaseBedrooms: React.PropTypes.func.isRequired,
  onDecreaseBedrooms: React.PropTypes.func.isRequired,
};

export default SizeStep;



// WEBPACK FOOTER //
// ./src/browser/steps/SizeStep/SizeStep.js